import styles from './style.module.css';

interface IProgress {
  value: number;
}

export function ProgressHorizontal({ value }: IProgress) {
  return (
    <>
      <div className={styles.progress}>
        <div
          className={styles.progressbar}
          style={{ width: `${value}%` }}
        ></div>
      </div>
    </>
  );
}
